// Date calculation prototype methods.
Date.prototype.addSeconds = function (seconds) {
    this.setSeconds(this.getSeconds() + seconds);

    return this;
};

Date.prototype.addMinutes = function (minutes) {
    this.setMinutes(this.getMinutes() + minutes);

    return this;
};

Date.prototype.addHours = function (hours) {
    this.setHours(this.getHours() + hours);

    return this;
};

Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + days);

    return this;
};

Date.prototype.addWeeks = function (weeks) {
    this.addDays(weeks * 7);

    return this;
};

Date.prototype.addMonths = function (months) {
    let dt = this.getDate();
    this.setMonth(this.getMonth() + months);

    let currDt = this.getDate();
    if (dt !== currDt) {
        this.addDays(-currDt);
    }

    return this;
};

Date.prototype.addYears = function (years) {
    let dt = this.getDate();
    this.setFullYear(this.getFullYear() + years);

    let currDt = this.getDate();
    if (dt !== currDt) {
        this.addDays(-currDt);
    }

    return this;
};